"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var PrismaKeyCodePattern = function PrismaKeyCodePattern() {
  this.codeName = "key", this.codeHeight = 87.61, this.codeWidth = 33.79, this.codeMargin = 6.13, this.codeLines = [23.65, 41.17, 58.69, 76.21];
};

exports.PrismaKeyCodePattern = PrismaKeyCodePattern;